import { render, staticRenderFns } from "./AdminCustomerDetails.vue?vue&type=template&id=3e414a79&scoped=true&"
import script from "./AdminCustomerDetails.vue?vue&type=script&lang=ts&"
export * from "./AdminCustomerDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e414a79",
  null
  
)

export default component.exports